module.exports = __webpack_public_path__ + "digitalAssets.e4f3743d302ce2e433b15192f683489b.png";